/**
 * Kickard PHASE 3.13.3 — Pure helper: compute Full Card Ledger deck-
 * accounting copy from the backend's `cardLuckV1.deckAccounting` payload.
 *
 * Extracted from MatchReportScreen so it can be unit-tested without
 * pulling in react-router / DOM / guest identity dependencies.
 *
 * Contract (backend fields consumed):
 *   expectedJokersTotal   — physical jokers in the deck(s) that were used
 *   receivedJokersTotal   — dealt + drawn to a player's hand
 *   revealOnlyJokersTotal — popped by Joker Shoot skip or DC / DC-defense
 *   jokersAccountedTotal  — received + revealOnly
 *   jokersUnaccountedTotal — expected - accounted (0 in a healthy match)
 */
export function computeDeckAccountingCopy(deckAccounting) {
  if (!deckAccounting || typeof deckAccounting !== 'object') {
    return { shouldRender: false };
  }
  const expected = Number(deckAccounting.expectedJokersTotal ?? 0);
  const accounted = Number(deckAccounting.jokersAccountedTotal ?? 0);
  const received = Number(deckAccounting.receivedJokersTotal ?? 0);
  const revealOnly = Number(deckAccounting.revealOnlyJokersTotal ?? 0);
  const unaccounted = Number(deckAccounting.jokersUnaccountedTotal ?? 0);
  if (expected <= 0) return { shouldRender: false };

  const mismatch = unaccounted > 0;
  const headline = mismatch
    ? `Joker accounting mismatch: ${accounted} / ${expected} accounted`
    : `Jokers accounted: ${accounted} / ${expected}`;
  const subtext = mismatch
    ? `${unaccounted} joker${unaccounted === 1 ? '' : 's'} unaccounted`
    : (revealOnly > 0
      ? `${received} received · ${revealOnly} revealed during Joker action`
      : `${received} received · 0 reveal-only`);
  return { shouldRender: true, mismatch, headline, subtext };
}
